(function ($) {


    this.init = function () {
        this.FinancialSolutions();
    };


    /****************************************************************
     HOMEPAGE BANNER
    ****************************************************************/
    this.FinancialSolutions = function () {
        $(".financialsolutions-selector-ctas-cta").on("click", clickSolutionLink);
        $(".financialsolutions-results-goback a").on("click", goBack);
    }
    function clickSolutionLink(event) {
        var $button = $(event.currentTarget);


        // Hide selector
        $(".financialsolutions-selector").hide();
        // Hide other results
        $(".financialsolutions-results").hide();
        // Show this results
        $("#" + $button.data("controls")).show();
    }
    function goBack() {
        // Hide each results
        $(".financialsolutions-results").hide();
        // Show Selector
        $(".financialsolutions-selector").show();

    }

    this.init();

})(jQuery);